export const ShortUrlID = 'media/';
export type ShortUrl = string;
